<form [formGroup]="formGroup">
  <mat-form-field>
    <wz-date-input
      placeholder="Date de prise d'effet de la garantie"
      formControlName="dateEffet"
    ></wz-date-input>
    <mat-error *ngIf="dateEffet.hasError('required')">{{
      'FORMS_DATE_REQUIRED' | wzI18n
    }}</mat-error>
    <mat-hint>{{ 'FORMS_DATE_HINT' | wzI18n }}</mat-hint>
    <mat-error *ngIf="dateEffet.hasError('min')"
      >La date de prise d'effet ne peut pas être antérieure à la date de
      paiement</mat-error
    >
    <mat-error *ngIf="dateEffet.hasError('max')"
      >La date de prise d'effet ne peut pas être supérieure à 1 mois et 5 jours
      après la date de paiement</mat-error
    >
    <mat-error *ngIf="dateEffet.hasError('invalid')"
      >Le format de la date est invalide</mat-error
    >
  </mat-form-field>
</form>
